import { render, staticRenderFns } from "./MenuItemHighlightedBox.vue?vue&type=template&id=7f8fa8ce&scoped=true"
import script from "./MenuItemHighlightedBox.vue?vue&type=script&lang=ts"
export * from "./MenuItemHighlightedBox.vue?vue&type=script&lang=ts"
import style0 from "./MenuItemHighlightedBox.vue?vue&type=style&index=0&id=7f8fa8ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8fa8ce",
  null
  
)

export default component.exports